<div asgClickHandler asgDeviceScreenAdjuster>
  <div asgRootLang>
    <router-outlet></router-outlet>
  </div>
  <asg-common-modal-window></asg-common-modal-window>
</div>

